import {Component, NgZone, OnInit} from '@angular/core';
import {FormGroup, FormControl, Validators, FormBuilder, Form, AbstractControl, ValidationErrors} from '@angular/forms';
import {AlertComponent} from 'app/popup/alert.component';
import {UtilityServiceService} from 'app/services/utility-service.service';
import {AuthWebService} from 'app/services/authweb.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from 'ng2-bootstrap-modal';
import {EqualvalidatorDirective} from 'app/validators/equalvalidator.directive';
import {Observable, concat} from 'rxjs';
import {environment} from 'environments/environment';
import {ToastrService} from 'ngx-toastr';
import {isNumeric} from 'rxjs/util/isNumeric';
import {SearchCountryField, TooltipLabel, CountryISO} from 'app/shared/projects/ngx-intl-tel-input/src/public_api';
import {SocialloginService} from '../services/sociallogin.service';
import {Socialusers} from '../models/socialusers';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {ViewChild} from '@angular/core';
import {ElementRef} from '@angular/core';

import {
    GoogleLoginProvider,
    FacebookLoginProvider,
    SocialAuthService,
    SocialUser,
} from 'angular12-social-login';
import {MsalService} from '@azure/msal-angular';
import {AuthenticationResult} from '@azure/msal-browser';
import {EmailExistsValidator} from '../validators/check-if-email-is-taken';
import {RegisterValidators} from '../validators/RegisterValidators';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

declare var emailValue;

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
    auth2: any;
    @ViewChild('loginRef', {static: true}) loginElement!: ElementRef;
    sKey: string = null;
    environment: string = null;
    socialLogin = false;
    hideSideMenu = false;
    socialusers = new Socialusers();
    response: any;
    isPhonePortrait = false;
    aUser: any = {};
    correspondenceType: string = null;
    sub: any;
    lblHeading = '';
    btnActionLabel = '';
    authenticator = '';
    isEdit: boolean;
    user = 'Haddad';
    isDup = false;
    selectedGroupCode: any = {};
    selectedDisplay = 3;
    reCaptcha: string = null;
    terms: string = null;
    // tslint:disable-next-line: no-inferrable-types
    loadingpage: boolean = false;
    public isLoading = false;
    message = null;
    mobnumPattern = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
    cbrtapattern = '^27[0-9]{9}$';
    form: any;
    email: any;
    numberisvalid = false;
    Roles: any[] = [];
    selectedRole: any;

    //SADC Countries
    separateDialCode = true;
    SearchCountryField = SearchCountryField;
    TooltipLabel = TooltipLabel;
    CountryISO = CountryISO;
    defaultCountry = CountryISO.SouthAfrica;
    defaultCountryPhone = CountryISO.SouthAfrica
    preferredCountries: CountryISO[] = [
        CountryISO.Angola,
        CountryISO.Botswana,
        CountryISO.Comoros,
        CountryISO.CongoDRCJamhuriYaKidemokrasiaYaKongo,
        CountryISO.Lesotho,
        CountryISO.Madagascar,
        CountryISO.Malawi,
        CountryISO.Mauritius,
        CountryISO.Mozambique,
        CountryISO.Namibia,
        CountryISO.Seychelles,
        CountryISO.Swaziland,
        CountryISO.Zambia,
        CountryISO.Zimbabwe,
    ];

  showCaptcha:boolean=false;
  ngZone: any;
  hide: boolean = true;
  hide2: boolean = true;
  isViewData: boolean = false;
   mobileNumber2:any;




    constructor(public authWebService: AuthWebService,
                private router: Router, private builder: FormBuilder,
                private route: ActivatedRoute, public utility: UtilityServiceService, private toastr: ToastrService,
                public OAuth: SocialAuthService, private SocialloginService: SocialloginService, private responsive: BreakpointObserver
        , private msalService: MsalService, private zone: NgZone, private emailExistsValidator: EmailExistsValidator,private toastService:ToastNotificationService) {
    }

    ngOnInit() {


        this.initForm();
        //this.onChanges();
        this.authWebService.getRegisterRoles();
        this.sKey = environment.captcha.siteKey;
        this.environment = environment.name;
        this.authWebService.getRegisterRolesObservable().subscribe((result) => {
            // this.Roles = result;

            result.forEach(role => {

                if (role.Code == 'GUEST' || role.Code == 'CONS') {

                    if (this.Roles.indexOf(role) < 0) {
                        this.Roles.push(role);
                    }
                }

            });


        });

        this.googleAuthSDK();

        this.responsive.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.TabletLandscape,
        ])
            .subscribe(result => {

                this.hideSideMenu = false;
                this.isPhonePortrait = false;

                if (result.matches) {
                    this.hideSideMenu = true;
                }

            });


    };



    callLogin() {

        this.auth2.attachClickHandler(this.loginElement.nativeElement, {},
            (googleAuthUser: any) => {

                //Print profile details in the console logs

                let profile = googleAuthUser.getBasicProfile();
                console.log('Token || ' + googleAuthUser.getAuthResponse().id_token);
                console.log('ID: ' + profile.getId());
                console.log('Name: ' + profile.getName());
                console.log('Image URL: ' + profile.getImageUrl());
                console.log('Email: ' + profile.getEmail());


                this.aUser.DateCreated = this.aUser.DateUpdated = new Date();
                // this.aUser.UserCreated = this.aUser.UserUpdated = this.user;
                this.aUser.ActiveYN = true;
                //   this.isLoading = true;
                //console.dir(this.aUser);
                this.aUser.UserName = profile.getEmail().toLowerCase();
                this.aUser.EmailAddress = profile.getEmail().toLowerCase();
                var SplittedName = profile.getName().split(' ');

                this.aUser.FirstName = SplittedName[1];
                this.aUser.LastName = SplittedName[0];
                this.aUser.Authenticator = 'Google';

                this.form.controls['FirstName'].setValue(SplittedName[1]);
                this.form.controls['LastName'].setValue(SplittedName[0]);
                this.form.controls['UserName'].setValue(profile.getEmail().toLowerCase());
                this.form.controls['EmailAddress'].setValue(profile.getEmail().toLowerCase());

                this.authenticator = 'Google';
                this.socialLogin = true;
                var element = document.getElementById('passwordfield');
                element.classList.add('d-none');
                var element1 = document.getElementById('passwordfieldnew');
                element1.classList.add('d-none');
                var _username = document.getElementById('ssoemailusername');
                _username.classList.add('d-none');
                var _confirmemail = document.getElementById('sooconfirmemail');
                _confirmemail.classList.add('d-none');

                console.log('User Data')
                console.log(this.aUser)


                // this.zone.run(() => this.authWebService.regitsersociallogin(this.aUser))

            }, (error: any) => {
                // alert(JSON.stringify(error, undefined, 2));
            });

    }

    googleAuthSDK() {

        (<any>window)['googleSDKLoaded'] = () => {
            (<any>window)['gapi'].load('auth2', () => {
                this.auth2 = (<any>window)['gapi'].auth2.init({
                    client_id: '42235825666-vl4kgsvsl4lvh7986v1dl2ifspe351tk.apps.googleusercontent.com',
                    plugin_name: 'login',
                    cookiepolicy: 'single_host_origin',
                    scope: 'profile email'
                });
                this.callLogin();
            });
        }

        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement('script');
            js.id = id;
            js.src = 'https://apis.google.com/js/platform.js?onload=googleSDKLoaded';
            fjs?.parentNode?.insertBefore(js, fjs);
        }(document, 'script', 'google-jssdk'));
    }

    public socialSignIn(socialProvider: string) {
        let socialPlatformProvider = '';
        if (socialProvider === 'facebook') {
            socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
        } else if (socialProvider === 'google') {
            socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
        }

        //  signInWithGoogle(): void {
        //     this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
        //   }

        //   signInWithFB(): void {
        //     this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
        //   }

        // this.OAuth.signIn(GoogleLoginProvider.PROVIDER_ID);

        // this.OAuth.signIn(FacebookLoginProvider.PROVIDER_ID);

        this.OAuth.signIn(socialPlatformProvider).then(
            (socialusers: SocialUser) => {
                console.log(socialProvider, socialusers);
                console.log(socialusers);
                // this.Savesresponse(socialusers);
                // this.form.value.FirstName = socialusers.firstName;
                this.form.controls['FirstName'].setValue(socialusers.firstName);
                this.form.controls['LastName'].setValue(socialusers.lastName);
                this.form.controls['UserName'].setValue(socialusers.email);
                this.form.controls['EmailAddress'].setValue(socialusers.email);


//     this.checkMobileNumber();

// if (!this.numberisvalid )
// {
//   return this.toastr.warning('Please check the Mobile Number','Registration failed');
// }


                this.message = 'Creating User Profile..';
                this.aUser.DateCreated = this.aUser.DateUpdated = new Date();
                this.aUser.UserCreated = this.aUser.UserUpdated = this.user;
                this.aUser.CommunicationType = this.correspondenceType === '2' ? 'SMS' : 'EMAIL';
                this.aUser.ActiveYN = true;
                this.isLoading = true;
                //console.dir(this.aUser);
                this.aUser.UserName = socialusers.email.toLowerCase();
                this.aUser.EmailAddress = socialusers.email.toLowerCase();
                this.aUser.FirstName = socialusers.firstName;
                this.aUser.Lastname = socialusers.lastName;
                this.aUser.Authenticator = 'Facebook';
                this.authenticator = 'Facebook';
                this.socialLogin = true;
                var element = document.getElementById('passwordfield');
                element.classList.add('d-none');
                var element1 = document.getElementById('passwordfieldnew');
                element1.classList.add('d-none');

                var _username = document.getElementById('ssoemailusername');
                _username.classList.add('d-none');
                var _confirmemail = document.getElementById('sooconfirmemail');
                _confirmemail.classList.add('d-none');
                //this.authWebService.registersociallogin(this.aUser);

                this.isLoading = false;

            }
        );
    }

    Savesresponse(socialusers: SocialUser) {
        this.SocialloginService.Savesresponse(socialusers).subscribe((res: any) => {
            debugger;
            console.log(res);
            this.socialusers = res;
            this.response = res.userDetail;
            localStorage.setItem('socialusers', JSON.stringify(this.socialusers));
            console.log(
                localStorage.setItem('socialusers', JSON.stringify(this.socialusers))
            );
            // this.router.navigate([`/Dashboard`]);
        });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.showCaptcha = true;
        }, 500);
    }


    initForm() {
        this.form = new FormGroup({
            ID: new FormControl()
            // , UserName: new FormControl(this.aUser.UserName, Validators.compose([Validators.required, <any>Validators.maxLength(100), Validators.pattern('[\\w\-\\s\\/]+')]))
            ,
            UserName: new FormControl(this.aUser.UserName, Validators.compose([
                Validators.required,
                Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]), [this.emailExistsValidator.validate])
            ,
            FirstName: new FormControl(this.aUser.FirstName, Validators.compose([Validators.required,
                Validators.minLength(2),
                Validators.maxLength(50),
                Validators.pattern(/^[a-zA-Z]+$/)]))
            ,
            LastName: new FormControl(this.aUser.LastName, Validators.compose([Validators.required,
                Validators.minLength(2),
                Validators.maxLength(50),
                Validators.pattern(/^[a-zA-Z]+$/)]))
            ,
            EmailAddress: new FormControl(this.aUser.EmailAddress, Validators.compose([Validators.required, Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]))
            //, MobileNumber: new FormControl(this.aUser.MobileNumber, Validators.compose([Validators.required,Validators.maxLength(11)]))
            ,
            MobileNumber: new FormControl(this.aUser.MobileNumber, Validators.required)
            // , PhoneNumber: new FormControl(this.aUser.PhoneNumber, Validators.compose([Validators.required,Validators.maxLength(10)]))
            ,
            PhoneNumber: new FormControl(this.aUser.PhoneNumber)// ^(\+27|0)[6-8][0-9]{8}$
            ,
            ActiveYN: new FormControl()
            ,
            Password: new FormControl('', Validators.compose([Validators.required,  Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm)]))
            ,
            ConfirmPassword: new FormControl('', Validators.compose([Validators.required]))
            //, terms: new FormControl(this.aUser.terms, Validators.required)
            ,
            DateCreated: new FormControl()
            ,
            UserCreated: new FormControl()
            ,
            UserUpdated: new FormControl()
            ,
            role: new FormControl()
        }, [RegisterValidators.match('Password', 'ConfirmPassword'), RegisterValidators.match('UserName', 'EmailAddress'),]);
        updateOn:'blur'
        this.form.patchValue(this.utility.defaults);
    }


    ngOnDestroy() {
        ///this.sub.unsubscribe();
    }

    onChange(event) {
        // //console.log(event.countryCode.toLowerCase());
        //  event.toLowerCase();
    }

    ChangeCountry(event) {
        this.defaultCountry = event.iso2;
    }

    ChangeCountryPhone(event) {
        this.defaultCountryPhone = event.iso2;
    }

    
    onSubmit(obj: any) {
        if (this.reCaptcha === null ){
        // return	this.dialogService.addDialog(AlertComponent, { title: 'Authentication failed', message: 'Are you a robot?' });
        // return this.toastr.warning('Are you a robot?','Authentication failed');
        return this.toastService.success('Authentication failed','Are you a robot?');
        
        }
       // this.validatePhone(this.form.value.MobileNumber);

        if (this.isDup) {
            return;
        }
        this.aUser = obj;

        this.message = 'Creating User Profile..';

        if (this.isDup) {
            return;
        }
        this.aUser = obj;
        this.mobileNumber2= this.aUser.MobileNumber;

        this.message = 'Creating User Profile..';

        if (this.form.value.MobileNumber !== undefined) {
            this.aUser.DialCodeMobile = this.form.value.MobileNumber.dialCode
            this.aUser.MobileNumber = this.form.value.MobileNumber.number
        }

        if (this.form.value.PhoneNumber !== undefined) {
            this.aUser.DialCodePhone = this.form.value.PhoneNumber.dialCode
            this.aUser.ISO2Phone = this.defaultCountryPhone;
            this.aUser.PhoneNumber = this.form.value.PhoneNumber.number
        }
        
        if (this.form.value.PhoneNumber !== undefined) {
            this.aUser.DialCodePhone = this.form.value.PhoneNumber.dialCode
            this.aUser.ISO2Phone = this.defaultCountryPhone;
            this.aUser.PhoneNumber = this.form.value.PhoneNumber.number
        }
        this.aUser.ISO2Mobile = this.defaultCountry;
        this.aUser.DateCreated = this.aUser.DateUpdated = new Date();
        this.aUser.UserCreated = this.aUser.UserUpdated = -1;
        this.aUser.CommunicationType = this.correspondenceType === '2' ? 'SMS' : 'EMAIL';
        this.aUser.ActiveYN = true;
        this.isLoading = true;
        this.aUser.RoleId = 0;
        this.selectedRole = this.Roles[0];
        if (this.selectedRole !== undefined) {
            this.aUser.RoleId = this.selectedRole.Id;
            this.aUser.Id = this.selectedRole.Id;
            // this.aUser.AuthUserRoles = this.selectedRole;
        }
        //console.dir(this.aUser);
        if (this.form.value.UserName !== null) {
            this.aUser.UserName = this.aUser.UserName.toLowerCase();
            this.aUser.EmailAddress = this.aUser.EmailAddress.toLowerCase();
        }

        //Validation
        let returnedErrors = this.validate(this.aUser);
        if (returnedErrors.length > 0) {
            return this.toastService.error(returnedErrors, 'Registration failed');
            // return this.toastr.warning(returnedErrors, 'Registration failed');
        }

        if(this.getAllErrors(this.form).length >0){
            return this.toastService.error("You have captured incorrectly one or more details, please check your details and try again", 'Registration failed');
        }

        if (this.socialLogin == false) {
            this.aUser.Authenticator = 'AuthWeb';
            this.authWebService.register(this.aUser);

        } else {
            this.aUser.Authenticator = this.authenticator;
            this.authWebService.registersociallogin(this.aUser);
        }

        this.isLoading = false;


    }

    navigate() {
        this.router.navigateByUrl('/login');
    }

    onDuplicates(control) {


    }

    checkMobileNumber() {
        //check length

        if (this.aUser.MobileNumber.trim().length >= 10) {
// how many spaces are in a string?
            var knt = this.aUser.MobileNumber.trim().split(' ').length - 1;
            //console.log("what is the count");
            //console.log(knt);
            var str = new String(this.aUser.MobileNumber.trim());
            for (let i = 0; i < knt; i++) {
                str = str.replace(' ', '');

            }

            //check char at first posn
            //console.log("number after trimming:");
            //console.log(str);
            if (str.charAt(0) === '+') {
                //remove + and check if rest can be converted to number
                if (isNumeric(str.slice(1))) {
                    //first char is + does it follow
                    if (str.slice(1).match('^27[0-9]{9}$')) {
                        //valid number
                        this.numberisvalid = true;
                        this.aUser.MobileNumber = str;

                    } else {
                        //not a match but starts with + perhaps a different country and is numeric
                        this.numberisvalid = true;
                        this.aUser.MobileNumber = str;
                    }

                } else {
                    //not numeric and if you remove what chars - or ( or )
                    var cnt_dash = str.split('-').length - 1;
                    var cnt_open_parenthesis = str.split('(').length - 1;
                    var cnt_close_parenthesis = str.split(')').length - 1;

                    //remove dash
                    for (let d = 0; d < cnt_dash; d++) {
                        str = str.replace('-', '');
                    }
                    //remove (
                    for (let e = 0; e < cnt_open_parenthesis; e++) {
                        str = str.replace('(', '');
                    }
                    //remove )
                    for (let f = 0; f < cnt_close_parenthesis; f++) {
                        str = str.replace(')', '');
                    }
                    if (isNumeric(str)) {
                        // removed characters and we have number that starts with a +
                        this.numberisvalid = true;
                        this.aUser.MobileNumber = '+' + str;
                        //console.log("new number stripped and + ");
                        //console.log(this.aUser.MobileNumber)
                    } else {
                        this.numberisvalid = false;
                    }

                }

            } else {
                //check if it is a number already
                if (isNumeric(str)) {
                    //chatAt(0) is not +
                    // is it a regular number? 0892345678

                    if (str.match('^0[1-9]{9}$')) {
                        //it starts with a zero and valid number
                        this.numberisvalid = true;
                        this.aUser.MobileNumber = '+27' + str.slice(1);
                        //console.log("new number");
                        //console.log(this.aUser.MobileNumber)
                    } else {
                        //it doesnt start with a 0 is it an international number?
                        this.numberisvalid = true;
                        this.aUser.MobileNumber = '+' + str;
                        //console.log("new number international");
                        //console.log(this.aUser.MobileNumber)

                    }

                } else {
                    //it is not a number remove the dashes - or ( or )

                    var cnt_dash = str.split('-').length - 1;
                    var cnt_open_parenthesis = str.split('(').length - 1;
                    var cnt_close_parenthesis = str.split(')').length - 1;

                    //remove dash
                    for (let d = 0; d < cnt_dash; d++) {
                        str = str.replace('-', '');
                    }
                    //remove (
                    for (let e = 0; e < cnt_open_parenthesis; e++) {
                        str = str.replace('(', '');
                    }
                    //remove )
                    for (let f = 0; f < cnt_close_parenthesis; f++) {
                        str = str.replace(')', '');
                    }


                    if (isNumeric(str)) {
                        // removed characters and we have number that starts with a +
                        this.numberisvalid = true;
                        this.aUser.MobileNumber = '+' + str;
                        //console.log("new number stripped and + ");
                        //console.log(this.aUser.MobileNumber)
                    } else {
                        this.numberisvalid = false;
                    }

                }

            }
        } else {
            this.numberisvalid = false;
        }
    }

    onChanges(): void {
        this.form.get('code').valueChanges.subscribe(code => {

            if (code.length > 3) {
                this.authWebService.checkByCode(code.trim()).subscribe(result => {
                    this.isDup = (result.Status && !this.isEdit) ? true : false;
                }, error => {
                    this.isDup = false;

                });
            }
        });
    }

    onChangeValue() {

    }

    selectcorrespondenceType(typeVal) {
        //console.log(typeVal)
        this.correspondenceType = typeVal;

    }

    onSelectChange() {
        console.dir(this.selectedDisplay);
    }

    ckeckTerms(event) {
        if (event.target.checked) {

            this.terms = 'clicked'
        } else {
            this.terms = null;
        }

    }

    resolved(captchaResponse: string) {
        //console.log(captchaResponse)
        this.reCaptcha = captchaResponse;
    }

    validateEmail(control) {

    }

    getErrorFirtsName() {
        return this.form.get('FirstName').hasError('required') ? 'First name is required' :
            this.form.get('FirstName').hasError('pattern') ? 'First Name entered is invalid' : '';
    }

    getErrorLastName() {
        return this.form.get('LastName').hasError('required') ? 'Last name is required' :
            this.form.get('LastName').hasError('pattern') ? 'Last Name entered is invalid' : '';
    }


    getErrorUsername() {
        return this.form.get('UserName').hasError('required') ? 'Email is required' :
            this.form.get('UserName').hasError('pattern') ? 'Email Address is invalid . Please enter a valid email address e.g:  name@example.com' : '';
    }

    getErrorEmail() {
        return this.form.get('UserName').hasError('required') ? 'Email is required' :
            this.form.get('UserName').hasError('pattern') ? 'Email Address is invalid . Please enter a valid email address e.g:  name@example.com' : '';
    }

    getConfirmEmail() {
        return this.form.get('EmailAddress').hasError('required') ? 'Confirmation Email Address is required' :
            this.form.get('EmailAddress').hasError('pattern') ? 'Email Address is invalid . Please enter a valid email address e.g:  name@example.com' :
                this.form.get('EmailAddress').hasError('notMatched') ? 'The Email Address and confirmation email address DO NOT MATCH' : '';
    }

    emailVerification(UserName, EmailAddress) {
        if (UserName != EmailAddress) {
            this.form.controls['EmailAddress'].setErrors({'notMatched': true});
        }
    }

//Password Guide
    getPasswordErr() {
        return this.form.get('Password').hasError('required') ? 'Password is required' :
            this.form.get('Password').hasError('pattern') ? 'Password must atleast be eight character long,including uppercase letter[A-Z], lowercase letter [a-z], number [0-9] and special character [@#$%*]' : '';
    }

    getConfirmPasswordErr() {
        return this.form.get('ConfirmPassword').hasError('required') ? 'Confirm Password is required' :
            //this.form.get('ConfirmPassword').hasError('pattern') ? 'Password to include atleast eight characters,including one uppercase [A-Z], one lowercase letter [a-z],one number [0-9] and one character [@#$%*] ' :'';
            this.form.get('ConfirmPassword').hasError('notMatched') ? 'Password do not match' : '';
    }

    validateFirstName() {

        if (this.aUser.FirstName.match(/[^0-9]/)) {
            return this.form.get('FirstName').hasError('required') ? 'Invalid First name' :
                this.form.get('FirstName').hasError('pattern') ? 'First Name is invalid . Please enter a valid first Name e.g:  Cross' : '';
        }
    }

    validateLastName() {
        if (this.aUser.LastName.match(/[^0-9]/)) {
            return this.form.get('LastName').hasError('required') ? 'Invalid Last name' :
                this.form.get('LastName').hasError('pattern') ? 'Last name is invalid . Please enter a valid last Name e.g:  Easy' : '';
        }
    }

    passwordMatch(Password, confirmPassword) {
        if (Password != confirmPassword) {
            this.form.controls['ConfirmPassword'].setErrors({'notMatched': true});
        }
    }

    getErrorPhoneNumber() {
        return this.form.get('PhoneNumber').hasError('required') ? 'Phone Number is required' :
            this.form.get('PhoneNumber').hasError('maxLength') ? 'Inavlid Mobile Number' :
                this.form.get('PhoneNumber').hasError('pattern') ? 'Mobile Number entered is invalid' : '';
    }

    getErrorMobileNumber() {
        return this.form.get('MobileNumber').hasError('required') ? 'Mobile Number is required' : '';
        //  this.form.get('MobileNumber').hasError('maxLength') ? 'Inavlid Mobile Number' : '';
    }

    public getAllErrors(form: FormGroup): string[] {
        const errors = [];
        Object.keys(form.controls).forEach(key => {
            const control = form.get(key);
            if (control && control.invalid) {
                Object.keys(control.errors).forEach(errorKey => {
                    errors.push(`${key} has error "${errorKey}"`);
                });
            }
        });
        return errors;
    }

    getErrorCorrespondenceType() {
        return this.form.get('correspondenceType').hasError('required') ? 'Correspondence is required' : '';
        //  this.form.get('MobileNumber').hasError('maxLength') ? 'Inavlid Mobile Number' : '';
    }

    getSiteKey() {
        return this.sKey
    }

    azureLogin() {
        this.msalService.loginPopup().subscribe((response: AuthenticationResult) => {
            if (response.account) {
                this.message = 'Loading...';
            }
            this.aUser.FirstName = response.account.name.substring(0, response.account.name.indexOf(' ')).trim();
            this.aUser.LastName = response.account.name.substring(response.account.name.indexOf(' ')).trim()
            this.aUser.UserCreated = this.aUser.UserUpdated = this.aUser.FirstName;
            this.aUser.CommunicationType = this.correspondenceType === '2' ? 'SMS' : 'EMAIL';
            this.isLoading = true;
            //console.dir(this.aUser);
            this.aUser.UserName = response.account.username.toLowerCase();
            this.aUser.EmailAddress = response.account.username.toLowerCase();
            this.aUser.Authenticator = 'Azure';
            this.authWebService.registerAzure(this.aUser);
        });
    }

    azureLogout() {
        this.msalService.logout();
    }

checked(){
  console.log("checked",this.selectedRole);
}
showPassword() {
  this.hide = !this.hide;
  }
  showPassword2() {
    this.hide2 = !this.hide2;
    }

    validate(aUser: any) {
        var msg: string = '';
        var count: number = 1;

        if (this.aUser.FirstName == null) {
            
            msg += '\n' + count + '. First name is required! ';
            count++;
        }

        if (this.aUser.LastName == null) {
            msg += '\n' + count + '. Last name is required! ';
            count++;
        }

        // if (this.aUser.MobileNumber == null) {
        //     console.log("Mobile Number is missing.");
        //     msg += '\n' + count + '. Mobile Number is required! ';
        //     count++;
        // }
        if (aUser.MobileNumber === null) {
            if (this.mobileNumber2 !== undefined) {
                aUser.MobileNumber = this.mobileNumber2;
            } else {
                msg += '\n' + count + '. Mobile Number is required! ';
                count++;
            }
        } else {
            this.mobileNumber2 = aUser.MobileNumber; // Update the fallback value
        }

        

        if (this.aUser.UserName == null) {
            msg += '\n' + count + '. Email is required! ';
            count++;
        }

        if (this.aUser.EmailAddress == null) {
            msg += '\n' + count + '. Confirm Email is required! ';
            count++;
        }

        if (this.aUser.Password == null || this.aUser.Password.length == 0) {
            msg += '\n' + count + '. Password is required! ';
            count++;
        }
        if (this.aUser.ConfirmPassword == null || this.aUser.ConfirmPassword.length == 0) {
            msg += '\n' + count + '. Confirm Password is required! ';
            count++;
        }

        if (this.aUser.RoleId == 0) {
            msg += '\n' + count + '. Please choose the role! ';
            count++;
        }

        if (this.reCaptcha === null && this.environment != 'qa' && this.environment != 'dev') {
            msg += count + '. Click on I am not a robot \n';
            count++;
        }

        if (this.terms === null) {
            msg += count + '.  Please click POPIA Processing Notice \n';
            count++;
        }

        if (this.correspondenceType === null) {
            msg += '\n' + count + '. Please select how you want to receive the confirmation link!';
            count++;
        }
        return msg;
    }


}
